import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js'  // 明确指定路由文件路径
import store from './store/index.js'    // 明确指定store文件路径
import axios from 'axios'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/theme.css'
import 'element-plus/es/components/table/style/css'
import 'element-plus/es/components/table-column/style/css'

// 配置axios
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'https://shiguangtongpin.cn'

// 添加请求拦截器
axios.interceptors.request.use(config => {
  // 添加token
  const token = localStorage.getItem('accessToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(response => {
  return response
}, error => {
  // 处理401未授权错误
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('userId')
    localStorage.removeItem('username')
    store.commit('setUser', null)
    router.push('/login')
  }
  return Promise.reject(error)
})

const app = createApp(App)
app.use(router)
app.use(store)
app.use(ElementPlus)
app.config.globalProperties.$axios = axios // 全局挂载axios

app.mount('#app')
